<ion-item button (click)="onClick()"><ng-content /></ion-item>
